import classnames from 'classnames';
import { FunctionComponent } from 'react';

type ClockProps = {
    className?: string;
};

const Clock: FunctionComponent<ClockProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'clock'}
            viewBox="0 0 250 250"
        >
            <path d="M125 .7C56.4.7.7 56.4.7 125S56.4 249.3 125 249.3 249.3 193.6 249.3 125 193.6.7 125 .7zm0 238.6C62 239.3 10.7 188 10.7 125S62 10.7 125 10.7 239.3 62 239.3 125 188 239.3 125 239.3z" />
            <polygon points="87.1,48.8 78,53.2 120.9,139 190,139 190,129 127.2,129" />
        </svg>
    );
};
export default Clock;
